module.exports = __webpack_public_path__ + "static/media/servicio_consultoria.be19048d.jpg";